// EditButton.tsx - A reusable edit button component
import React from 'react';
import { Edit } from 'lucide-react';
import { __ } from '../translations';

interface EditButtonProps {
  postId: number;
  className?: string;
}

const EditButton: React.FC<EditButtonProps> = ({ postId, className = '' }) => {
  // Only show edit button to administrators
  if (!boardMemberData.isAdmin) {
    return null;
  }

  //const editUrl = `${boardMemberData.restURL.replace('/wp-json', '')}/wp-admin/post.php?post=${postId}&action=edit`;

  return (
    <a 
    href={`/wp-admin/post.php?post=${postId}&action=edit`}
      className={`inline-flex items-center px-3 py-1 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md text-sm transition-colors ${className}`}
      target="_blank"
      rel="noopener noreferrer"
      title={__('Edit this post')}
    >
      <Edit className="w-4 h-4 mr-1" />
      {__('Edit')}
    </a>
  );
};

export default EditButton;